import { styled } from '@mui/material/styles';
import { Outlet } from 'react-router-dom';
import { FiscalDetailSearch, FiscalDetailDataGrid } from '../components';
import FiltersLayoutHandler from '../components/FiltersLayoutHandler';
import { reportFiscalDetailLoadingSelector } from '../state';

export const Container = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  '.MuiToolbar-root': {
    marginTop: theme.spacing(3),
  },
}));

const FiscalDetail = () => (
  <Container>
    <FiltersLayoutHandler selector={reportFiscalDetailLoadingSelector}>
      <FiscalDetailSearch />
    </FiltersLayoutHandler>
    <FiscalDetailDataGrid />
    <Outlet />
  </Container>
);

export default FiscalDetail;
